import { render, staticRenderFns } from "./create-or-edit-column-info.vue?vue&type=template&id=60b85198&scoped=true"
import script from "./create-or-edit-column-info.vue?vue&type=script&lang=js"
export * from "./create-or-edit-column-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b85198",
  null
  
)

export default component.exports